import { useEffect, useState } from 'react';

const API_URL = process.env.REACT_APP_BACKEND_URL;

export const LAYOVER_DEFAULTS = {
  arrival_min: 45, ist_oldcity_min: 60, saw_kadikoy_min: 40, saw_oldcity_min: 90,
  return_buffer_min: 150, min_layover_hours: 7, transfer_times_status: 'default — owner to confirm',
  group_max: 10, tier_currency: 'USD',
  tiers: { '7h': { p1_3: null, p4_6: null, p7_10: null }, '8h': { p1_3: null, p4_6: null, p7_10: null }, '10h': { p1_3: null, p4_6: null, p7_10: null } },
  entrance_fees: [], entrance_fees_checked: '', ta_url_layover: '',
};

let cache = null;
export function useLayoverConfig() {
  const [cfg, setCfg] = useState(cache || LAYOVER_DEFAULTS);
  useEffect(() => {
    if (cache) return;
    fetch(`${API_URL}/api/layover/config`).then(r => r.json()).then(d => { cache = { ...LAYOVER_DEFAULTS, ...d }; setCfg(cache); }).catch(() => {});
  }, []);
  return cfg;
}

export const transferMin = (cfg, airport, destination) =>
  airport === 'SAW' ? (destination === 'oldcity' ? cfg.saw_oldcity_min : cfg.saw_kadikoy_min) : cfg.ist_oldcity_min;

export const timeInCity = (cfg, airport, layoverMin, destination = 'default') =>
  layoverMin - cfg.arrival_min - 2 * transferMin(cfg, airport, destination) - cfg.return_buffer_min;

export const fmtHM = (min, lang = 'en') => {
  const ar = lang === 'ar';
  if (min <= 0) return ar ? '0 د' : '0 min';
  const h = Math.floor(min / 60), m = min % 60;
  const mm = String(m).padStart(2, '0');
  if (ar) return h ? `${h} س${m ? ` ${mm} د` : ''}` : `${m} د`;
  return h ? `${h}h${m ? ` ${mm}` : ''}` : `${m} min`;
};

export const verdictFor = (min) => (min < 60 ? 'none' : min < 150 ? 'short' : 'full');

export const TIER_KEYS = ['7h', '8h', '10h'];
export const PAX_KEYS = ['p1_3', 'p4_6', 'p7_10'];

export const tierPrices = (cfg, key) => {
  const t = cfg.tiers?.[key];
  return t && t.p1_3 != null ? t : null;
};

export const tierFor = (cfg, key, pax) => {
  const t = cfg.tiers?.[key];
  const v = t?.[pax <= 3 ? 'p1_3' : pax <= 6 ? 'p4_6' : 'p7_10'];
  return v == null ? null : v;
};

export const tierRange = (cfg, key = null) => {
  const vals = (key ? [key] : TIER_KEYS).flatMap(k => PAX_KEYS.map(p => cfg.tiers?.[k]?.[p])).filter(v => v != null);
  return vals.length ? { low: Math.min(...vals), high: Math.max(...vals) } : null;
};

export const fmtPrice = (cfg, v) => (v == null ? '—' : `${v} ${cfg.tier_currency}`);

export const GUARANTEE = (cfg, lang = 'en') => lang === 'ar'
  ? `نعيدك إلى المطار قبل موعد المغادرة بـ${fmtHM(cfg.return_buffer_min, 'ar')}. وإن تأخرت رحلتك القادمة، نعيد الجدولة أو نلغي دون أي تكلفة.`
  : `We have you back at the airport ${fmtHM(cfg.return_buffer_min)} before departure. If your inbound flight is delayed, we reschedule or cancel at no cost.`;
